import { Routes } from '@angular/router';
import { ShellComponent } from './layout/shell';
import { authGuard, roleGuard } from './core/guards/auth.guard';
import { Role } from './core/models/role.enum';

export const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        data: { breadcrumb: 'Áttekintés' },
        loadComponent: () =>
          import('./features/dashboard/dashboard').then((m) => m.DashboardComponent),
      },
      {
        path: 'assets',
        data: { breadcrumb: 'Eszközök' },
        loadChildren: () =>
          import('./features/assets/assets.routes').then((m) => m.assetsRoutes),
      },
      {
        path: 'hr',
        data: { breadcrumb: 'HR' },
        canActivate: [roleGuard(Role.ADMIN, Role.HR_MANAGER, Role.HR_VIEWER)],
        loadChildren: () =>
          import('./features/hr/hr.routes').then((m) => m.hrRoutes),
      },
      {
        path: 'settings',
        data: { breadcrumb: 'Értesítési beállítások' },
        canActivate: [roleGuard(Role.ADMIN, Role.NOTIFICATION_MANAGER, Role.NOTIFICATION_VIEWER)],
        loadComponent: () =>
          import('./features/settings/deadline-settings/deadline-settings').then((m) => m.DeadlineSettingsComponent),
      },
      {
        path: 'documents',
        data: { breadcrumb: 'Dokumentumtár' },
        canActivate: [roleGuard(Role.ADMIN, Role.DOCUMENT_MANAGER, Role.DOCUMENT_VIEWER)],
        loadComponent: () =>
          import('./features/documents/document-list/document-list').then((m) => m.DocumentListComponent),
      },
      {
        path: 'my-profile',
        data: { breadcrumb: 'Saját profil' },
        loadComponent: () =>
          import('./features/hr/my-profile/my-profile').then((m) => m.MyProfileComponent),
      },
      {
        path: 'unauthorized',
        loadComponent: () =>
          import('./features/unauthorized/unauthorized').then((m) => m.UnauthorizedComponent),
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./features/not-found/not-found').then((m) => m.NotFoundComponent),
  },
];
